import { useMutation } from 'react-apollo';
import { useHistory } from 'react-router-dom';
import { ESTIMATE, ESTIMATE_SYSTEMS } from '../../../../queries';

const normalizeValues = (items = []) =>
  items
    .map((item) => parseFloat(item && item.value))
    .filter((value) => !Number.isNaN(value) && value > 0);

export const useOnSubmit = ({ estimateId, getImage, mutation }) => {
  const history = useHistory();
  const [mutate] = useMutation(mutation, {
    onCompleted: () => history.push(`/estimates/${estimateId}`),
  });

  return (values) => {
    const fileName = `mark_${values.mark.toUpperCase()}.svg`;
    const widths = normalizeValues(values.widths);
    const elevations = normalizeValues(values.elevations);
    const totalHeight = elevations[elevations.length - 1];

    const verticals = widths.map((width, index) => ({
      index,
      width,
      lHeight: totalHeight,
      rHeight: totalHeight,
      lites: elevations,
      price: values.price.toString(),
    }));

    const variables = {
      ...(values.id && { id: values.id }),
      ...(!values.id && { estimateId: values.estimateId }),
      type: 'sf',
      mark: values.mark,
      qty: parseInt(values.qty, 10),
      glassCompositionId: values.glassCompositionId,
      frameColorId: values.frameColorId,
      verticals,
      details: [],
      image: getImage(fileName),
      autoPrice: values.autoPrice,
    };

    mutate({
      variables,
      refetchQueries: [{ query: ESTIMATE, variables: { id: estimateId } }],
      ...(!values.id && {
        update: (cache, { data: { systemCreateStorefront } }) => {
          const data = cache.readQuery({
            query: ESTIMATE_SYSTEMS,
            variables: { id: estimateId },
          });
          data.estimate.systems = [systemCreateStorefront].concat(
            data.estimate.systems
          );
          cache.writeQuery({
            query: ESTIMATE_SYSTEMS,
            variables: { id: estimateId },
            data,
          });
        },
      }),
    });
  };
};
